import { useCallback, useState } from 'react';
import { Element } from 'react-bulma-components';
import ResolutionScalingWarningModal from '../resolution-scaling-warning-modal/resolution-scaling-warning-modal';
import styles from './resolution-scaling-warning-header.module.scss';

const WARNING_MESSAGE_TEXT =
  'Your screen resolution is too small. This may be due to the resolution scaling set up by your operating system. For an optimal experience, please zoom out until you see the 4 main sections in the home screen in the same line (My Sales Orders, My Devices, My Software, My Team). ';

export function ResolutionScalingWarningHeader() {
  const [showModal, setShowModal] = useState(false);

  const handleWarningClick = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleOnClose = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <>
      <Element p={4} className={styles.container}>
        <span>{WARNING_MESSAGE_TEXT}</span>
        <span
          onClick={handleWarningClick}
          className="has-text-primary is-underlined is-clickable"
        >
          Click here
        </span>
        <span> if you need help.</span>
      </Element>
      <ResolutionScalingWarningModal show={showModal} onClose={handleOnClose} />
    </>
  );
}

export default ResolutionScalingWarningHeader;
